import HealthRepository from './HealthRepository';
import { InfrastructureHealthResponse, SourcesKpisHealth } from './HealthTypes';

export default class HealthService {
	private repository: HealthRepository;

	constructor() {
		this.repository = new HealthRepository();
	}

	async getSourcesKpisHealth(): Promise<SourcesKpisHealth> {
		return this.repository.getSourcesKpisHealth();
	}

	async getInfrastructuresHealth(
		page: number,
		size: number,
		parameterId?: number,
		search?: string,
	): Promise<InfrastructureHealthResponse> {
		return this.repository.getInfrastructuresHealth(page, size, parameterId, search);
	}
}
